import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserCompanyAccess, removeUser } from "../utils/userSlice";
import useRequireAuth from "../utils/useRequireAuth";

import useClickOutside from "../hooks/Screen/useClickOutside";
import { useLocation } from "react-router-dom";
import { getUserTokeData } from "../utils/userSlice";
import Notification from "./userProfile/Notification";
import { getInitials } from "../utils/utilityFunctions/stringUtility";
import { Avatar } from "@mui/material";
import { deepPurple } from "@mui/material/colors";
import { ReactComponent as HeaderNotifyImg } from "../assets/images/headerNotifyImg.svg";

import { ReactComponent as ViewAllOtherNotis } from "../assets/images/viewAllOtheNotis.svg";
import { ReactComponent as DownAngleBracket } from "../assets/images/downAngleBracket.svg";
import Notifications from "../assets/images/icons/Notifications";

import { useSidebar } from "../components/SidebarContext";
import TopTitle from "./GlobalFeature/TopTitle";
import { ReactComponent as ProfileIcon } from "../assets/images/icons/ProfileIcon.svg";
import { ReactComponent as PrivacyIcon } from "../assets/images/icons/PrivacyIcon.svg";

import { ReactComponent as SettingIcon } from "../assets/images/icons/SettingIcon.svg";

import { ReactComponent as LogoutIcon } from "../assets/images/icons/LogoutIcon.svg";
import ConfirmationDialog from "./UniversalComponents/ConfirmationDialogBox";
import AvatarName from "./UniversalComponents/AvatarName";
import { checkAccessPermission, getOrganizationName } from "../utils/utilityFunctions/localServices";

const Header = () => {
  const user = useRequireAuth();
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useRequireAuth();
  const [isSettingdropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen, setProfileDropdownOpen] = useState(false);
  const [notification, setnotification] = useState(false);
  const [notifications, setnotifications] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const myUserDataString = localStorage.getItem("myUserData");
  const myUserData = JSON.parse(myUserDataString);
  const userData = useSelector((store) => store?.user);

  const handleProfileClick = () => {
    Navigate("/User_Profile_Details");
  };

  // Accessing Header Props for TopTitle

  const sidebarContext = useSidebar();
  const headerProps = sidebarContext?.headerProps;

  const location = useLocation();

  useEffect(() => {
    dispatch(getUserTokeData());
    dispatch(getUserCompanyAccess());
  }, [location]);

  let userToken = token || JSON.parse(localStorage.getItem("myUserData")).token;

  const SettingtoggleDropdown = () => {
    if (notifications) {
      setnotifications(false);
    }
    if (dropdownOpen) {
      setProfileDropdownOpen(false);
    }
    setDropdownOpen(!isSettingdropdownOpen);
  };

  const Notificationopen = () => {
    if (isSettingdropdownOpen) {
      isSettingdropdownOpen(false);
    }
    if (dropdownOpen) {
      setProfileDropdownOpen(false);
    }
    setnotifications(true);
  };

  const ProfiletoggleDropdown = () => {
    if (notification) {
      setnotification(false);
    } else if (isSettingdropdownOpen) {
      setDropdownOpen(false);
    }
    setProfileDropdownOpen(!dropdownOpen);
  };

  // const initialName = user?.name;
  // const name = initialName ? initialName.split(" ")[0].charAt(0).toUpperCase() : "";
  // useEffect(() => {
  //   setUserName(initialName);
  // }, [initialName]);
  const initialName = user?.name;
  const nameInitials = initialName
    ? initialName
        .split(" ") // Split the full name into an array
        .filter((word) => word.length > 0) // Remove any empty spaces
        .slice(0, 2) // Take only the first two words (first and last name)
        .map((word) => word.charAt(0).toUpperCase()) // Extract first letter and capitalize
        .join("") // Join letters together
    : "";

  const handleDeleteConfirmation = () => {
    setShowConfirmation(true);
  };

  const handleSignOut = async () => {
    setShowConfirmation(true);
    const Authtoken = user.token;

    try {
      // Dont deleted commented below (below code is for server side validation)

      // const response = await fetch(LOGOUT_URL, {
      //   method: "POST",
      //   headers: {
      //     Authorization: `Bearer ${Authtoken}`,
      //   },
      // });

      // if (!response.ok) {
      //   throw new Error("Logout failed");
      // }
      dispatch(removeUser(null));

      Navigate("/");
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  const handelManagePermission = () => {
    Navigate("/company_permission");
  };

  const handelCompanyDelegation = () => {
    Navigate("/company-and-permission");
  };

  const closeSettingoutSideClick = useClickOutside(() => {
    setDropdownOpen(false);
  });

  const closePoup = () => {
    setnotifications(false);
  };

  const closeProfileoutSideClick = useClickOutside(() => {
    setProfileDropdownOpen(false);
  });

  return (
    <nav className="w-full bg-white z-[1200] sticky top-0 drop-shadow-[0px_-1px_4px_rgba(0,0,0,0.25)]">
      <div className="px-3 py-[7px] lg:px-5  ">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start rtl:justify-end">
            <span className="text-[#1D4469] text-20 font-medium font-Vietnam">{getOrganizationName()}</span>
          </div>

          <div className="flex items-center">
            <div className="flex items-center ms-3">
              {isSettingdropdownOpen && (
                <div className="top-14 absolute bg-white border right-4 p-5 shadow-3 rounded-lg h-[446px] w-[900px]">
                  <div className="flex justify-around" ref={closeSettingoutSideClick}>
                    <div className="group">
                      <h3
                        // className="mb-5 text-203C50 text-16 font-500 border-b-2 border-white group-hover:border-b-2 group-hover:border-203C50"
                        className="mb-5 text-gray-300 text-16 font-500"
                      >
                        Settings
                      </h3>
                      <div>
                        <ul className="space-y-4 text-gray-300 text-14 font-400 capitalize">
                          <li>Company Settings</li>
                          <li
                          // className="hover:text-black cursor-pointer"
                          >
                            Chart Of Accounts
                          </li>
                          <li>Payroll Settings</li>
                          <li>Workers Comp</li>
                          <li>HR Advisor</li>
                          <li>Employee Benefits</li>
                          <li>Get the desktop App</li>
                          <li>Additional Info</li>
                          <li>Priority Circle</li>
                        </ul>
                      </div>
                    </div>
                    <div className="group">
                      <h3
                        // className="mb-5 text-203C50 text-16 font-500 border-b-2 border-white group-hover:border-b-2 group-hover:border-203C50"
                        className="mb-5 text-gray-300 text-16 font-500"
                      >
                        Lists
                      </h3>
                      <div>
                        <ul className="space-y-4 text-gray-300 text-14 font-400 capitalize ">
                          <li>All List</li>
                          <li>Products & Services</li>
                          <li>recurring Transactions</li>
                          <li>Attachment</li>
                          <li>Custom Field</li>
                          <li>tags</li>
                          <li>Rules</li>
                        </ul>
                      </div>
                    </div>
                    <div className="group">
                      <h3
                        // className="mb-5 text-203C50 text-16 font-500 border-b-2 border-white group-hover:border-b-2 group-hover:border-203C50"
                        className="mb-5 text-gray-300 text-16 font-500"
                      >
                        Tools
                      </h3>
                      <div>
                        <ul className="space-y-4 text-gray-300 text-14 font-400 capitalize ">
                          <li>Manage Workflow</li>
                          <li>Order Checks</li>
                          <li>Import Data</li>
                          <li>Import Desktop Data</li>
                          <li>Reconcile</li>
                          <li>Budgeting</li>
                          <li>Spreadsheet Sync</li>
                          <li>Audit Log</li>
                          <li>Smart Look</li>
                          <li>Resolution Center</li>
                        </ul>
                      </div>
                    </div>
                    <div className="group">
                      <h3 className="mb-5 text-203C50 text-16 font-500  border-b-2 border-white group-hover:border-b-2 group-hover:border-203C50">
                        Your Company
                      </h3>
                      <div>
                        <ul className="space-y-4 text-gray-300 text-14 font-400 capitalize ">
                          <li>Subscription & Billing</li>
                          <li>Getting Started</li>
                          <li>Sample Company</li>
                          <li>Feedback</li>

                          {checkAccessPermission("Add & Manage Groups & Permission") && (
                            <li
                              className="hover:text-black cursor-pointer text-778FA5"
                              onClick={handelCompanyDelegation}
                            >
                              Company Delegation
                            </li>
                          )}
                          {/* <li className="hover:text-black cursor-pointer text-778FA5" onClick={handelManagePermission}>
                            Roles And Permission
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div
              // className="p-1 px-3 border-e-2"
              >
                <button
                  id="dropdownNotificationButton"
                  data-dropdown-toggle="dropdownNotification"
                  className="relative inline-flex items-center text-sm font-medium text-center text-gray-500 mx-2 "
                  type="button"
                  onClick={Notificationopen}
                >
                  {notifications ? <Notifications notifications={notifications} /> : <Notifications />}
                  <div className="absolute block w-3 h-3 bg-red-500 border-2 border-white rounded-full -top-0.5 start-1.5 dark:border-gray-900"></div>
                </button>

                {notifications && (
                  <div
                    className="absolute top-[11px] right-0 "
                    // ref={closeNotificationOutSideClick}
                  >
                    <Notification open={notifications} onClose={closePoup} />
                  </div>
                )}
                <div
                  id="dropdownNotification"
                  className="z-20 hidden w-full max-w-sm bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-800 dark:divide-gray-700"
                  aria-labelledby="dropdownNotificationButton"
                >
                  <div className="block px-4 py-2 font-medium text-center text-gray-700 rounded-t-lg bg-gray-50 dark:bg-gray-800 dark:text-white">
                    Notifications
                  </div>
                  <div className="divide-y divide-gray-100 dark:divide-gray-700">
                    <a href="#" className="flex px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700">
                      <div className="flex-shrink-0">
                        <div className="absolute flex items-center justify-center w-5 h-5 ms-6 -mt-5 bg-blue-600 border border-white rounded-full dark:border-gray-800">
                          <HeaderNotifyImg />
                        </div>
                      </div>
                      <div className="w-full ps-3">
                        <div className="text-gray-500 text-sm mb-1.5 dark:text-gray-400">
                          New message from{" "}
                          <span className="font-semibold text-gray-900 dark:text-white">Jese Leos</span>: "Hey, what's
                          up? All set for the presentation?"
                        </div>
                        <div className="text-xs text-blue-600 dark:text-blue-500">a few moments ago</div>
                      </div>
                    </a>
                    {/* Other notifications */}
                    <div className="p-1 px-3 border-e-2">
                      <i className="bi bi-question-circle text-lg"></i>
                    </div>
                  </div>
                  <a
                    href="#"
                    className="block py-2 text-sm font-medium text-center text-gray-900 rounded-b-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white"
                  >
                    <div className="inline-flex items-center ">
                      <ViewAllOtherNotis />
                      View all
                    </div>
                  </a>
                </div>
              </div>
              <div className="px-3 border-l-2 border-[#53525266]" ref={closeProfileoutSideClick}>
                <div className=" ">
                  <button
                    id="dropdownAvatarNameButton"
                    data-dropdown-toggle="dropdown-user"
                    className="capitalize flex items-center text-base pe-1 font-medium text-1D4469 hover:text-cyan-500 md:me-0"
                    type="button"
                    fdprocessedid="7lar5b"
                    onClick={ProfiletoggleDropdown}
                  >
                    <span className="sr-only">Open user menu</span>
                    <span className="flex items-center flex-row gap-2">
                      <AvatarName
                        name={nameInitials}
                        size="medium"
                        bgColor={"#e8ecf299"}
                        textColor={"#7C7C83"}
                        borderColor={"#ABABAC"}
                      />
                      <span className="authname"> {user?.name}</span>
                    </span>
                    {console.log("avtar001", nameInitials)}

                    <DownAngleBracket className="w-2.5 h-2.5 ms-3" />
                  </button>
                </div>
                {dropdownOpen && (
                  <div>
                    <div className="bg-white absolute mt-5 border rounded-lg shadow w-60 right-6">
                      <div className="p-3">
                        <ul className="ml-0 space-y-2">
                          <li
                            className="text-778FA5 p-2 bg-1D4469 rounded font-medium text-14"
                            // onClick={handleProfileClick}
                          >
                            <div className="flex">
                              <div className="mr-5">
                                <AvatarName
                                  name={getInitials(user?.name)}
                                  size="medium"
                                  bgColor={"#673ab7"}
                                  textColor={"#ffffff"}
                                  // borderColor={"#ffffff"}
                                />
                              </div>
                              <div className="flex items-center">
                                <p className="capitalize text-white text-14 font-500 cursor-pointer">{user?.name}</p>
                                {/* <p>
                                  <span className="text-12 text-ffffffb3 font-500">
                                    User Id:
                                  </span>
                                  <span className="text-12 font-500 text-ffffffb3">
                                    {user?.id}
                                  </span>
                                </p> */}
                              </div>
                            </div>
                          </li>
                          <li className="text-778FA5 flex cursor-pointer hover:text-1D4469 group hover:bg-[#F3F5F7] items-center gap-5 p-2 bg-white hover:bg-F3F5F7  rounded font-400 hover:font-400 text-14 hover:border-l-2 hover:border-1D4469 border-l-2 border-white">
                            <ProfileIcon className=" fill-[#969BA9] group-hover:fill-[#1D4469]" />
                            My Account
                          </li>
                          <li className="text-778FA5 hover:text-1D4469 cursor-pointer p-2 bg-white flex group gap-5 hover:bg-[#F3F5F7] items-center rounded font-400 hover:font-400 text-14 hover:border-l-2 hover:border-1D4469 border-l-2 border-white">
                            <PrivacyIcon className=" fill-[#969BA9] group-hover:fill-[#1D4469]" />
                            Privacy
                          </li>
                          <li
                            onClick={SettingtoggleDropdown}
                            className="text-778FA5 hover:text-1D4469 p-2 cursor-pointer bg-white hover:bg-[#F3F5F7] group flex gap-5 rounded items-center font-400 hover:font-400 text-14 hover:border-l-2 hover:border-1D4469 border-l-2 border-white"
                          >
                            <SettingIcon className=" fill-[#969BA9] group-hover:fill-[#1D4469]" />
                            Setting
                          </li>
                          <li
                            onClick={handleDeleteConfirmation}
                            className="text-778FA5 hover:text-1D4469 p-2 bg-white cursor-pointer hover:bg-[#F3F5F7] ml-1 group flex gap-5 rounded items-center font-400 hover:font-400 text-14 hover:border-l-2 hover:border-1D4469 border-l-2 border-white"
                          >
                            <LogoutIcon className=" fill-[#969BA9] group-hover:fill-[#1D4469]" />
                            Logout
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {showConfirmation && (
                <ConfirmationDialog
                  open={showConfirmation}
                  onConfirm={handleSignOut}
                  onClose={() => setShowConfirmation(false)}
                  title="Logout"
                  message={`Are you sure , Do you want to Logout ?`}
                  confirmVariant="primary"
                  confirmText="Yes"
                  // cancelVariant="action"
                  cancelText="No"
                  // variant="delete"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
